module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Animali_Selvatici_Vaganti.5fd38b4e.svg";